import { Link } from 'react-router-dom';
import FadeInSection from '@/components/base/FadeInSection';

const certificates = [
  {
    id: 'fssai',
    title: 'FSSAI Registration',
    subtitle: 'Food Safety & Standards Authority of India',
    description: 'FSSAI registered under Registration Number 22726396000236 — ensuring compliance with national food safety standards for fresh produce supply.',
    image: '/images/FSSI_license_page-0001.jpg',
    color: 'primary',
  },
  {
    id: 'msme',
    title: 'MSME Registration',
    subtitle: 'Ministry of Micro, Small & Medium Enterprises',
    description: 'Udyam registered under UDYAM-UP-44-0039003 — Government of India recognized Micro Enterprise for trading.',
    image: '/images/UdyamRegistrationCertificate_page-0001.jpg',
    color: 'accent',
  },
  {
    id: 'gst',
    title: 'GST Registration',
    subtitle: 'Goods & Services Tax',
    description: 'GST registered under 09ESWPB5086D1ZB — enabling transparent B2B transactions and professional billing across India.',
    image: '/images/gst_basharat_page-0001.jpg',
    color: 'secondary',
  },
];

const colorMap: Record<string, { bg: string; iconBg: string; text: string; badge: string; border: string }> = {
  primary: {
    bg: 'bg-primary-50 border-primary-200',
    iconBg: 'bg-primary-100',
    text: 'text-primary-600',
    badge: 'bg-primary-100 text-primary-700',
    border: 'border-primary-200',
  },
  accent: {
    bg: 'bg-accent-50 border-accent-200',
    iconBg: 'bg-accent-100',
    text: 'text-accent-600',
    badge: 'bg-accent-100 text-accent-700',
    border: 'border-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-50 border-secondary-200',
    iconBg: 'bg-secondary-100',
    text: 'text-secondary-600',
    badge: 'bg-secondary-100 text-secondary-700',
    border: 'border-secondary-200',
  },
};

export default function Certifications() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <FadeInSection>
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-4">
            Trust & Compliance
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Our <strong className="text-primary-600">Certifications</strong>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            We are fully registered and compliant with Indian regulatory standards, giving our business partners complete confidence.
          </p>
        </div>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {certificates.map((cert, idx) => {
            const c = colorMap[cert.color];
            return (
              <FadeInSection key={cert.id} delay={idx * 120}>
              <div
                className={`group relative bg-background-50 border ${c.border} rounded-xl overflow-hidden hover:shadow-md transition-all duration-300 hover:-translate-y-1`}
              >
                {/* Certificate Preview Image */}
                <div className="relative w-full h-48 bg-background-100 flex items-center justify-center overflow-hidden">
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className="w-full h-full object-contain object-top p-3"
                  />
                  <div className="absolute top-3 right-3">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 bg-primary-500 text-background-50 rounded-full text-[10px] font-semibold whitespace-nowrap`}>
                      <i className="ri-verified-badge-fill text-xs"></i>
                      Verified
                    </span>
                  </div>
                </div>

                <div className="p-5 md:p-6">
                  <span className={`inline-block px-3 py-1 ${c.badge} rounded-full text-xs font-semibold mb-3`}>
                    {cert.subtitle}
                  </span>

                  <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">
                    {cert.title}
                  </h3>

                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                    {cert.description}
                  </p>

                  <Link
                    to="/certificates"
                    className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-semibold transition-colors"
                  >
                    View Certificate
                    <i className="ri-arrow-right-line text-lg"></i>
                  </Link>
                </div>
              </div>
              </FadeInSection>
            );
          })}
        </div>

        <FadeInSection>
        <div className="text-center mt-10">
          <Link
            to="/certificates"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap"
          >
            View All Certificates
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
        </FadeInSection>
        </div>
    </section>
  );
}